import React, {Component} from 'react'

import {goodSorts} from '../../../../universal-src/model/goods'
import CatalogPageLayout from './layout'

const sortOptions = goodSorts.map(sort => ({value: sort.name, title: sort.title}))

let globalViewType = null
let globalSort = null
let globalSearchQuery = ''

class CatalogPageController extends Component {
  state = {
    searchQuery: globalSearchQuery,
    viewType: globalViewType || this.props.currentUser.catalogSettings.viewType,
    sort: globalSort || this.props.currentUser.catalogSettings.sort,
  }

  updateSettings = () => {
    this.props.updateCatalogSettings({
      variables: {
        viewType: this.state.viewType,
        sort: this.state.sort
      }
    })
  }

  setSearchQuery = (searchQuery) => {
    this.setState({searchQuery})
    globalSearchQuery = searchQuery
  }

  setViewType = (viewType) => {
    this.setState({viewType}, this.updateSettings)
    globalViewType = viewType
  }

  setSort = (sort) => {
    this.setState({sort}, this.updateSettings)
    globalSort = sort
  }

  render() {
    return <CatalogPageLayout
      {...this.props}
      searchQuery={this.state.searchQuery}
      setSearchQuery={this.setSearchQuery}
      viewType={this.state.viewType}
      setViewType={this.setViewType}
      sortOptions={sortOptions}
      sort={this.state.sort}
      setSort={this.setSort}
    />
  }
}

export default CatalogPageController
